export const GloneVI = {
    "glone": {
        title : "Danh sách ngạch lương",
        "columns": {
            "code": "Mã ngạch",
            "name": "Tên ngạch",
            "gloneCfgPosition": "Vị trí",
            "creator": "Người tạo",
        },
        "label": {
            "name": "Tên ngạch",
            "code": "Mã ngạch",
            "positions": "Vị trí",
            "ordinal": "Cấp",
            "typeSalaryId": "Hình thức lương",
            "primaryMoney": "Số tiền",
        }
    }

}